import { useDispatch } from "react-redux";
import HomeBannerListComponent from "../../components/home/banners/HomeBannerListComponent";
import HomeCategoryListComponent from "../../components/home/categories/HomeCategoryListComponent";
import HomeDetailsCardsListComponent from "../../features/homePage/detailsCards/list/HomeDetailsCardsListComponent";
import HomeItemsGalleryComponent from "../../features/homePage/itemsGallery/HomeItemsGalleryComponent";
import usePagination from "../../hooks/usePagination";
import productActions from "../../store/actions/products/product.actions";

import "../../styles/pages/home/homePageComponent.scss";
import { objectsHelper } from "../../helpers/objects.helper";

export const HomePageComponent = () => {
  const dispatch = useDispatch();

  // Recommended Products
  const { items: recommendedItems } = usePagination({
    queryKey: ["products", "recommended"], // Unique key for recommended
    fetchFunction: async (pageParam) => {
      return await dispatch(
        productActions.getProducts({
          pageNumber: pageParam,
          pageSize: 100,
          isRecommended: true,
        })
      );
    },
  });

  // Hot Sell Products
  const { items: hotSellItems } = usePagination({
    queryKey: ["products", "hot-sell"], // Unique key for hot sell
    fetchFunction: async (pageParam) => {
      return await dispatch(
        productActions.getProducts({
          pageNumber: pageParam,
          pageSize: 100,
          isHotSell: true,
        })
      );
    },
  });

  // New Arrival Products
  const { items: newArrivalItems } = usePagination({
    queryKey: ["products", "new-arrivals"], // Unique key for new arrivals
    fetchFunction: async (pageParam) => {
      return await dispatch(
        productActions.getProducts({
          pageNumber: pageParam,
          pageSize: 100,
          isNewArrival: true,
        })
      );
    },
  });



  return (
    <div className="homePageContainer">
      <HomeBannerListComponent />
      <HomeCategoryListComponent />
      <HomeDetailsCardsListComponent />

      {objectsHelper.listHasData(recommendedItems) && <HomeItemsGalleryComponent title="המומלצים שלנו" items={recommendedItems} />}
      {objectsHelper.listHasData(hotSellItems) && <HomeItemsGalleryComponent title="הנמכרים ביותר" items={hotSellItems} />}
      {objectsHelper.listHasData(newArrivalItems) && <HomeItemsGalleryComponent title="מוצרים חדשים" items={newArrivalItems} />}
      {/* <HomePageCategoryListComponent /> */}
      {/* <HomeAboutUsComponent /> */}
    </div>
  );
};

export default HomePageComponent;
